/* Return shoppers to their own storefront page, not a fixed collection. */
(function () {
  'use strict';
  var key = 'bj:continue-shopping';
  var blocked = /\/(?:cart|checkout|checkouts|account)(?:\/|$)/i;

  function storefrontUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, location.origin);
      if (url.origin !== location.origin || blocked.test(url.pathname)) return '';
      return url.pathname + url.search + url.hash;
    } catch (_) { return ''; }
  }
  function previousPage() {
    var referrer = storefrontUrl(document.referrer);
    if (referrer) return referrer;
    try { return storefrontUrl(sessionStorage.getItem(key)); } catch (_) { return ''; }
  }
  function rememberPage() {
    var current = storefrontUrl(location.href);
    if (current) {
      try { sessionStorage.setItem(key, current); } catch (_) {}
    } else {
      var previous = previousPage();
      if (previous) document.querySelectorAll('[data-bj-continue-shopping]').forEach(function (link) {
        link.href = previous;
      });
    }
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-bj-continue-shopping]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var drawer = link.closest('cart-drawer');
    if (drawer && storefrontUrl(location.href) && typeof drawer.close === 'function') {
      event.preventDefault();
      drawer.close();
      return;
    }
    var previous = previousPage();
    if (previous) {
      event.preventDefault();
      location.assign(previous);
    }
  });
  rememberPage();
  window.addEventListener('pageshow', rememberPage);
})();
